export default "__VITE_ASSET__DFDY3yqK__"